
import React from 'react';
import './Palletinjects.css';
import Plasticpalletinjec from '../../../imgs/Plasticpalletinjec.webp'; 

const Palletinjects = () => {
  return (
    <div className="Palletinje-wrapper">
      <div className="Palletinje-card">
        <img src={Plasticpalletinjec} alt="Application" className="Palletinje-img" />
      </div>
    </div>
  );
};

export default Palletinjects;
